module.exports = __webpack_public_path__ + "img/img_footer.f015543a.png";